import React from 'react';
import {Stack, Text, Badge, Group} from '@mantine/core';
import {IconUsers} from '@tabler/icons-react';

type SharedTeamsProps = {
    teams: Array<{
        id: string;
        name: string;
    }>;
};

export const SharedTeams = ({teams}: SharedTeamsProps) => {
    if (teams.length === 0) {
        return null;
    }

    return (
        <Stack gap="xs">
            <Group gap="xs">
                <IconUsers size={16} />
                <Text size="sm" fw={500}>
                    Shared Teams
                </Text>
            </Group>
            <Group gap="xs">
                {teams.map((team) => (
                    <Badge
                        key={team.id}
                        variant="light"
                        size="md"
                    >
                        {team.name}
                    </Badge>
                ))}
            </Group>
        </Stack>
    );
};
